module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-range",
    class: {
      'date-range--view-only': _vm.isActivated
    }
  }, [_c('span', {
    staticClass: "date-range__label"
  }, [_vm._v("From")]), _vm._v(" "), _c('span', {
    staticClass: "date-range__value",
    on: {
      "click": _vm.createStartPopover
    }
  }, [_vm._v(_vm._s(_vm.startDateName) + " "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 12,
      "height": 8
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "date-range__label"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "date-range__value",
    on: {
      "click": _vm.createEndPopover
    }
  }, [_vm._v(_vm._s(_vm.endDateName) + " "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 12,
      "height": 8
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-269d653a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/dateRange/DateRange.vue
// module id = 1846
// module chunks = 0